import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as marketingOptions from '../reducers/marketing-options.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

export const geMarketingOptionsState = createSelector(getAuthState, state => state[marketingOptions.marketingOptionsFeatureKey]);

export const getNewUserPasscodeRequest = createSelector(geMarketingOptionsState, marketingOptions.getMarketingOptionsRequest);

export const getNewUserPasscodeFailure = createSelector(geMarketingOptionsState, marketingOptions.getMarketingOptionsFailure);
